// src/hooks/usePreventZoom.js
import { useEffect } from 'react';

/**
 * Hook para prevenir el zoom automático en dispositivos móviles
 * cuando el usuario toca inputs con font-size < 16px
 */
export const usePreventZoom = () => {
  useEffect(() => {
    const preventZoom = (e) => {
      // Solo aplicar en dispositivos táctiles
      if ('ontouchstart' in window) {
        const target = e.target;
        
        // Si es un input, textarea o select
        if (target.matches('input, textarea, select')) {
          // Asegurar que el font-size sea al menos 16px
          const currentFontSize = window.getComputedStyle(target).fontSize;
          const fontSize = parseFloat(currentFontSize);
          
          if (fontSize < 16) {
            target.style.fontSize = '16px';
          }
        }
      }
    };

    // Añadir listeners para focus
    document.addEventListener('focusin', preventZoom);
    document.addEventListener('touchstart', preventZoom);

    // Limpiar listeners al desmontar
    return () => {
      document.removeEventListener('focusin', preventZoom);
      document.removeEventListener('touchstart', preventZoom);
    };
  }, []);

  useEffect(() => {
    // Función adicional para ajustar viewport en dispositivos móviles
    const adjustViewport = () => {
      if (window.innerWidth <= 768) {
        const viewport = document.querySelector('meta[name="viewport"]');
        if (viewport) {
          viewport.setAttribute('content', 
            'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
          );
        }
      }
    };

    // Ejecutar al cargar y al cambiar orientación
    adjustViewport();
    window.addEventListener('orientationchange', adjustViewport);
    window.addEventListener('resize', adjustViewport);

    return () => {
      window.removeEventListener('orientationchange', adjustViewport);
      window.removeEventListener('resize', adjustViewport);
    };
  }, []);
};